import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {apiRequest} from "../../components/Utils/SimmsUtils";

async function selectUserGroups(search, pageable, success) {
    return apiRequest(
        () => needAuth.post(`/usergroups/page?${getPageable(pageable)}`, search),
        success
    )
}

async function selectUserGroupsAsList(search) {
    try {
        return await needAuth.post(`/usergroups/list`, search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const data = error.response.data;
            const status = error.response.status;
            return {data, status};
        }
    }
}

async function updateUserGroupMenusByUserGroup(data, success) {
    return apiRequest(
        () => needAuth.post(`/usergroups/${data.userGroupId}/menus`, data),
        success
    )
}

async function updateUserGroupByUserGroup(userGroupId, data, success) {
    return apiRequest(() => needAuth.put(`/usergroups/${userGroupId}`, data), success);
}

async function saveUserGroup(data, success, duplicated) {
    return apiRequest(
        () => needAuth.post(`/usergroups`, data),
        success,
        duplicated,
    );
}

async function getUserGroup(userGroupId) {
    try {
        return await needAuth.get(`/usergroups/${userGroupId}`)
    } catch (error) {
        if (error instanceof AxiosError) {
            const data = error.response.data;
            const status = error.response.status;
            return {data, status};
        }
    }
}

async function deleteUserGroup(userGroupId, success, failToDelete) {
    return apiRequest(() => needAuth.delete(`/usergroups/${userGroupId}`), success, failToDelete);
}

const getPageable = (pageable) => {
    let pageStr = "";
    let sort = "sort=";
    let size = '&size=';
    let page = '&page=';
    const desc = ',desc';
    if (pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if (pageable.size) {
        size += pageable.size;
    }
    page += pageable.page;
    pageStr = sort + size + page;
    return pageStr;
}

export {
    selectUserGroups,                   // 유저그룹 목록조회
    getUserGroup,                       // 유저그룹 단일조회
    updateUserGroupMenusByUserGroup,    // 유저그룹 메뉴관리 수정
    updateUserGroupByUserGroup,         // 유저그룹 기본정보 수정
    deleteUserGroup,                    // 유저그룹 단일삭제
    saveUserGroup,                      // 유저그룹 단일저장
    selectUserGroupsAsList
}